import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import {
  integer,
  required,
  maxLength
} from "vuelidate/lib/validators";

export default {
  name: "adminEdit",
  components: {
    MainLayout,
    Select2Multiple,
    Loading,
  },

  data() {
    return {
      itemData: [],
      submitted: false,
      isLoading: false,
      disabled: false,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      itemExists: false,
    };
  },

  validations: {
    itemData: {
      p_item_name: {
        required,
        maxLength: maxLength(100)
      },
      p_item_amount: {
        required,
        integer,
        maxLength: maxLength(9)
      },
    },
  },

  methods: {
    async checkDuplicateItem() {
        try {
            const response = await axios.get("/item/checkDuplicateItem", {
                params: {
                    id: this.itemData.id,
                    item_name: this.itemData.p_item_name,
                },
            });
            this.itemExists = response.data.exists;
            this.submitted = false;
            this.disabled = false;
        } catch (error) {
            console.error('An error occurred:', error);
        }
    },

    getDetail() {
      axios.get(`item/detail/${this.$route.params.id}`)
        .then(res => {
          if (res.data) {
            this.itemData = res.data.data;
          }
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        })
    },

    async confirmUpdate() {
        this.submitted = true;
        this.disabled = true;
        await this.checkDuplicateItem();
        if (this.itemExists) {
          this.$notification.error("Payment Item Name is already exist.", {
            timer: 3,
            position: "bottomCenter"
          });
          return;
        }
        this.update();
    },

    update() {
      this.submitted = true;
      if (this.$v.$invalid) {
        return;
      }
      this.itemData.loginID = this.$store.state.user.id;
      this.disabled = true;
      axios.post(`item/update/${this.$route.params.id}`, this.itemData)
        .then(res => {
          if (res.data.success === true) {
            this.$notification.success("Item Updated Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "itemList"
            });
          } else {
            this.disabled = false;
            this.$notification.error(res.data.message, {
              timer: 3,
              position: "bottomCenter",
            });
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        })
    }
  },

  mounted() {
    this.isLoading = true;
    this.getDetail();
  },
};
